import React from "react";

import { ColoredCardGridBlock as ColoredCardGridBlockValue } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonTextPrimary } from "../Clickables";
import { H, HLevel } from "../Headings";
import { Svg } from "../Svg";
import { getThemeClass } from "../ThemedModule";

import styles from "./ColoredCardGrid.module.scss";

interface ColoredCardGridProps {
    value: ColoredCardGridBlockValue;
}

export const ColoredCardGrid = ({ value }: ColoredCardGridProps) => {
    return (
        <HLevel>
            <section className={styles.root}>
                <div className={styles.grid}>
                    {value.cards?.map((card, index) => (
                        <article
                            key={index}
                            className={concatClassNames([
                                styles.card,
                                getThemeClass(card.color),
                            ])}
                        >
                            {card.image && (
                                <div className={styles.imageBlock}>
                                    <ImageChooserBlock
                                        value={card.image}
                                        attrs={{}}
                                    />
                                </div>
                            )}
                            <div className={styles.textBlock}>
                                {card.headline && (
                                    <H className={styles.headline}>
                                        {card.headline}
                                    </H>
                                )}
                                {card.body && (
                                    <p className={styles.body}>{card.body}</p>
                                )}
                                {card.cta?.display_name && (
                                    <ButtonTextPrimary
                                        simpleLink={card.cta}
                                        className={styles.cta}
                                    >
                                        {card.cta.display_name}
                                        <Svg name="arrow" />
                                    </ButtonTextPrimary>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </HLevel>
    );
};
